/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressBarSquareComponent} from './progress-bar-square.component';

@NgModule({
    declarations: [ProgressBarSquareComponent],
    exports: [
        ProgressBarSquareComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ProgressBarSquareModule {
}
